


























import Vue from 'vue'
import CameraMicControls from '@/components/CameraMicControls'
import { UserProfile } from '@/types/users'
import { Cast } from '@/types/casts'
import { SourceStream } from '@/types/streams'
import { TranscodingRegion } from '@/types/admin'
import { KeyDict } from '@/types'
import SubscribeWowzaStats from '@/mixins/SubscribeWowzaStats'
import WRTCLoadbalancer from '@/classes/WRTCLoadbalancer'

export default Vue.extend({
  name: 'CameraMicControlsContainer',
  props: {
    republish: {
      type: Boolean
    },
    presenceId: {
      type: String
    }
  },
  mixins: [ SubscribeWowzaStats ],
  computed: {
    currentCast (): Cast | null {
      return this.$store.direct.state.events.currentCast
    },
    currentUserId (): string {
      return this.$store.direct.state.user.id
    },
    localCameraStream (): MediaStream | null {
      console.log('x-x-x- mediaStream', this.$store.direct.state.events.localCameraStream)
      return this.$store.direct.state.events.localCameraStream
    },
    casting (): boolean {
      return this.$store.direct.state.events.casting
    },
    castingAs (): string {
      return this.$store.direct.state.events.castingAs
    },
    invitedCasters (): object  {
      return this.$store.direct.getters.events.invitedCasters
    },
    transcodingregions (): KeyDict<TranscodingRegion>  {
      return this.$store.direct.state.admin.transcodingregions
    },
    userProfile (): UserProfile | null  {
      return this.$store.direct.getters.user.userProfile
    },
    castStreams (): object {
      return this.$store.direct.state.streams.castStreams
    },
    sourceStreams (): KeyDict<SourceStream> {
      return this.$store.direct.state.events.sourceStreams
    },
    selfMute (): boolean {
      return this.$store.direct.state.events.selfMute
    },
    currentUserIsACaster (): boolean {
      let isCaster = false
      const userId = this.userProfile?.assignedId ?? this.userProfile?.id
      if (this.currentCast !== null && userId) {
        const caster = this.currentCast?.invited_casters?.[userId]
        if (caster && !caster.deleted) {
          isCaster = true
        }
      }
      if (this.casting && isCaster) {
        if (isCaster && this.castingAs === 'noncaster') {
          console.log('stop casting as noncaster after inviting a talkback user to an event')
          this.killLocalCameraStream()
        }
      }
      return isCaster
    },
    wrtcserver () {
      let server = 'wrtc-va1.kiswe.com'
      if (this.currentCast !== null && this.currentCast.hasOwnProperty('wrtcserver')) {
        server = this.currentCast.wrtcserver
      }
      if (this.userProfile !== null && this.userProfile.transcodingregion !== undefined) {
        const loadbalancer = new WRTCLoadbalancer()
        const region = this.$store.direct.state.admin.transcodingregions[this.userProfile.transcodingregion]
        const wowzastats = this.$store.direct.state.opsmonitor.wowzastats
        if (region !== undefined && wowzastats !== undefined) {
          const loadbalancedServer = loadbalancer.getServerUrlToStreamTo(region, wowzastats)
          if (loadbalancedServer !== undefined) server = loadbalancedServer
        }
      }
      return server
    }
  },
  methods: {
    setCurrentCasterStream (stream) {
      this.$store.direct.dispatch.events.setCurrentCasterStream(stream)
    },
    setLocalCameraStream (stream) {
      this.$store.direct.dispatch.events.setLocalCameraStream(stream)
    },
    killLocalCameraStream () {
      this.$store.direct.dispatch.events.killLocalCameraStream()
    },
    setTalkbackStatus (talkback) {
      this.$store.direct.dispatch.events.setTalkbackStatus(talkback)
    },
    toggleSelfMute (mute) {
      this.$store.direct.dispatch.events.toggleSelfMute(mute)
    },
  },
  components: {
    CameraMicControls
  }
})
